export default interface ILeadNote {
    id: number;
    leadId: number;
    text: string;
    userName: string
    createdAt: Date;
}

export interface ILeadNoteResponseModel {
    id: number;
    text: string;
    userName: string;
    createdAt: string;
}

export function mapLeadNoteResponseModel(model: ILeadNoteResponseModel, leadId: number): ILeadNote {
    return {
        id: model.id,
        leadId: leadId,
        text: model.text,
        userName: model.userName,
        createdAt: new Date(model.createdAt),
    };
}
